import { render, staticRenderFns } from "./CardVddl.vue?vue&type=template&id=17038297&scoped=true&"
import script from "./CardVddl.vue?vue&type=script&lang=js&"
export * from "./CardVddl.vue?vue&type=script&lang=js&"
import style0 from "./CardVddl.vue?vue&type=style&index=0&id=17038297&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17038297",
  null
  
)

export default component.exports